<template>
  <div class="page-wrapper">
    <the-email-header />
    <div class="mt-32">
      <TheCaseModificationContent />
    </div>
  </div>
</template>

<script setup lang="ts" name="TheEmailModificationTemplate">
import { onMounted } from "vue";
import { useRoute } from "vue-router";
import TheEmailHeader from "@/components/email/TheEmailHeader.vue";
import TheCaseModificationContent from "./TheCaseModificationContent.vue";

const route = useRoute();

onMounted(() => {
  const { lang } = route.query;
  if (lang) {
    localStorage.setItem("language", lang);
  }
});
</script>

<style>
.page-wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
</style>